import type { ClaimType, ClaimTypeGroup, PreferredOutcome } from '../../types/claims.types';

export interface ClaimTypeOption { value: ClaimType; label: string; }
export interface OutcomeOption { value: PreferredOutcome; label: string; sub: string; }

export const CLAIM_TYPES: Record<ClaimTypeGroup, ClaimTypeOption[]> = {
  standard: [
    { value: 'pump_nozzle_defect', label: 'Pumpe / dyse defekt' },
    { value: 'damaged_on_arrival', label: 'Beskadiget ved levering' },
    { value: 'wrong_delivery', label: 'Forkert levering' },
    { value: 'other', label: 'Andet' },
  ],
  elektronik: [
    { value: 'electronics_power_button', label: 'Tænd/sluk-knap' },
    { value: 'electronics_magnet_ring', label: 'Magnetring' },
    { value: 'electronics_display_error', label: 'Display-fejl' },
    { value: 'electronics_wont_turn_on', label: 'Vil ikke tænde' },
    { value: 'electronics_brush_error', label: 'Børste-fejl' },
  ],
};

export const OUTCOMES: OutcomeOption[] = [
  { value: 'credited', label: 'Kreditering', sub: 'Beløbet krediteres salonen' },
  { value: 'replacement_sent', label: 'Erstatningsvare', sub: 'Ny vare sendes' },
];

export const TYPE_LABEL: Record<string, string> = Object.fromEntries(
  Object.values(CLAIM_TYPES).flat().map((t) => [t.value, t.label])
);

/** Frontend-regel: Elektronik-kategori → elektronik-typer, ellers standard. */
export function typeGroup(category: string): ClaimTypeGroup {
  return category === 'Elektronik' ? 'elektronik' : 'standard';
}
